__turbopack_context__.v({
  "fadeInItems": "Video-module__CRJXgW__fadeInItems",
  "spacing--lg": "Video-module__CRJXgW__spacing--lg",
  "spacing--md": "Video-module__CRJXgW__spacing--md",
  "spacing--sm": "Video-module__CRJXgW__spacing--sm",
  "spacing--xl": "Video-module__CRJXgW__spacing--xl",
  "spacing--xs": "Video-module__CRJXgW__spacing--xs",
  "spacing--xxl": "Video-module__CRJXgW__spacing--xxl",
  "spacing--xxs": "Video-module__CRJXgW__spacing--xxs",
  "spacing--xxxl": "Video-module__CRJXgW__spacing--xxxl",
  "spacing--xxxs": "Video-module__CRJXgW__spacing--xxxs",
  "video": "Video-module__CRJXgW__video",
});
